import React, { useState, useEffect, useCallback } from "react";
import { Grid, CardHeader, CardContent, Box, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Helmet } from "react-helmet-async";
import { Form, FormikProvider, useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CardLayout from "../../layouts/CardLayout";
import errorHandler from "../../utils/errorHandler";
import { userSchema } from "../../utils/Schema";
import { userServices } from "../../services/AllServices";

function AddEditTruckOwner() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const handlePaste = (e) => {
    const pastedText = e.clipboardData.getData("text");
    if (/^\d/.test(pastedText)) {
      e.preventDefault();
    }
  };

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await userServices.getById({ id });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchTaskData();
  }, [fetchTaskData]);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: userSchema,
    initialValues: {
      name: data?.name || "",
      address: data?.address || "",
    },
    onSubmit: async (values) => {
      setLoading(true);
      try {
      
        const response = id
          
        
        
        && await userServices.edit({
             id: id || undefined,
          name: values.name,
          address: values.address,
          status: "active",
          })
          // : await userServices.add(payload);
        toast.success(response?.data?.message, { toastId: "success" });
        navigate(-1);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const { values, touched, errors, handleChange, handleSubmit } = formik;

  return (
    <Box>
      <Helmet>
        <title>{id ? "Edit" : "Add"} Truck Owner</title>
      </Helmet>
      <CardLayout>
        <CardHeader title={`${id ? "Edit" : "Add"} Truck Owner`} />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={6} md={6}>
                  <TextField
                    fullWidth
                    label="Name"
                    required
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onPaste={handlePaste}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    fullWidth
                    label="Address"
                    required
                    name="address"
                    value={formik.values.address}
                    onChange={handleChange}
                    error={Boolean(
                      formik.touched.address && formik.errors.address
                    )}
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box mt={3}>
                    <LoadingButton
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      loading={loading}
                    >
                      {id ? "Update" : "Add"} User
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default AddEditTruckOwner;
